import Vue from 'vue'
export const BusEmisor = new Vue();
export default BusEmisor;



// WEBPACK FOOTER //
// ./src/js/BusEmisor.js